import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemDialog from "../UIToolkit/Popups/Dialog";

type SaveAsDefaultDialogProps = {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void | Promise<void>;
	/**
	 * Root test ID; `SystemDialog` derives `-confirm-button` and `-cancel-button` from it.
	 *
	 * Optional because five surfaces share this dialog and each needs its OWN prefix to be
	 * distinguishable in a test — one shared literal here would make them ambiguous. Callers that pass
	 * nothing render as before, with no selectors.
	 */
	dataTestId?: string;
	/** A consequence this particular save has on top of the usual one (e.g. it replaces everyone's job colours). */
	extraNotice?: string;
};

export const SaveAsDefaultDialog: FC<SaveAsDefaultDialogProps> = ({ open, onClose, onConfirm, dataTestId, extraNotice }) => {
	const { t } = useTranslation();

	return (
		<SystemDialog
			open={open}
			onClose={onClose}
			title={t("settings.save.as.default.confirm.title")}
			body={extraNotice ? `${t("settings.save.as.default.confirm.body")} ${extraNotice}` : t("settings.save.as.default.confirm.body")}
			onConfirm={onConfirm}
			dataTestId={dataTestId}
		/>
	);
};
